var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('CampaignLevels')],1),_c('div',{staticClass:"mt-4"},[_c('CampaignStreams')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }